import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
    state: false,
    id: 0
};
export const templateSlice = createSlice({
    initialState: INITIAL_STATE,
    name: '@@TEMPLATES',
    reducers: (create)=>({
            setDirtyState: create.reducer((state, { payload: { id, _state = true, handleSuccess } })=>{
                handleSuccess === null || handleSuccess === void 0 ? void 0 : handleSuccess();
                return {
                    ...state,
                    id,
                    state: _state
                };
            })
        })
});
